import React from "react";
import { connect } from "react-redux";

import { Button, Icon } from "antd";

import { updateBetSlip } from "../../../redux/actions/betSlipActions";
import { SessionStorage } from "../../../helpers";

class EventOddField extends React.Component {
  state = {
    changeStatus: 0,
  };
  componentDidUpdate(prevProps, prevState) {
    const {oddField , openBallsContainer  ,ballCount}=this.props
    if (prevProps.oddField.enableBet && !oddField.enableBet && openBallsContainer){
      openBallsContainer(undefined, undefined, undefined, undefined , undefined , undefined)
    }
    if (this.props.oddField.oddValue !== prevProps.oddField.oddValue) {
      this.setState({ changeStatus: this.props.oddField.oddValueStatus });
      this.timeout = setTimeout(() => this.setState({ changeStatus: 0 }), 2000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const {
      oddField,
      showDetails,
      betSlipField,
      showFieldName,
      fromDrillDown,
      removeSpecialField,
      ballCount,
      openBallsContainer,
      betTypeGroupName,
      activeOddFieldId,
    } = this.props;
    const openLuckyNumberBalls =ballCount && oddField && oddField.betType && (oddField.betType.betTypeId == 1 || oddField.betType.betTypeId == 2 || oddField.betType.betTypeId == 3 )
    const isSameButton = activeOddFieldId == oddField.activeOddFieldId;
    let luckyNumberDrawInfo = {
      betTypeGroupName: betTypeGroupName,
      activeOddFieldId: oddField.activeOddFieldId,
      oddField: oddField,
      selectedBalls: [],
      bonusBalls: [],
      ballColor: undefined,
    };
    if (isSameButton)
      luckyNumberDrawInfo = {
        betTypeGroupName: undefined,
        activeOddFieldId: undefined,
        oddField: undefined,
        selectedBalls: [],
        bonusBalls: [],
        ballColor: undefined,
      };
    if (!oddField) {
      return (
        <Button disabled>
          <div className="lock">
            <Icon type="lock" />
          </div>
        </Button>
      );
    }
    return (
      <Button
        disabled={
          !oddField.enableBet ||
          !oddField.eventEnableBet ||
          !oddField.oddEnableBet
        }
        className={`${
          betSlipField
            ? "selected"
            : activeOddFieldId == oddField.activeOddFieldId
            ? "selected"
            : ""
        } ${this.state.changeStatus == 1 ? "up" : ""} ${
          this.state.changeStatus == -1 ? "down" : ""
        }`}
        onClick={(e) =>
          (openLuckyNumberBalls)
            ? openBallsContainer(
                luckyNumberDrawInfo.betTypeGroupName,
                luckyNumberDrawInfo.activeOddFieldId,
                luckyNumberDrawInfo.oddField,
                luckyNumberDrawInfo.selectedBalls,
                luckyNumberDrawInfo.bonusBalls,
                luckyNumberDrawInfo.ballColor
              )
            : this.onFieldClick(e, oddField)
        }
      >
        <div className="container">
          {(!oddField.enableBet ||
            !oddField.eventEnableBet ||
            !oddField.oddEnableBet) && (
            <div className="container">
              {fromDrillDown && <span style={{padding:"5px 10px 5px 10px"}}>{oddField.oddFieldDisplayName}</span>}
              <div className="value"><Icon type="lock"/></div>
            </div>
          )}
          {oddField.enableBet &&
            oddField.eventEnableBet &&
            oddField.oddEnableBet && (
              <>
                {fromDrillDown && (
                  <div className="value bold">
                    {oddField.oddFieldDisplayName}{" "}
                    {oddField.oddSpecialField &&
                      oddField.oddSpecialField !== "-1" && (
                        <span style={{ marginLeft: "3px" }}>
                          {removeSpecialField ? `` : oddField.oddSpecialField}
                        </span>
                      )}
                  </div>
                )}
                <div className="value bold" style={{ opacity: "0.5" }}>
                  {oddField.oddValue.format(2)}
                </div>
              </>
            )}
        </div>
      </Button>
    );
  }

  onFieldClick(e, field) {
    e.preventDefault();
    e.stopPropagation();
    const {drawEvents , updateBetSlip} = this.props
    let beslipField;
    if(drawEvents){
      beslipField={...field , drawEvents:drawEvents ,selectedDraws: [drawEvents[0]], selectedDrawsIds:[drawEvents[0].eventId]}
    }else{
      beslipField= field
    }

    let betTab = SessionStorage.betTab;
    if (betTab == 1) {
      updateBetSlip({
        ...beslipField,
        amount: (!this.props.hideStake && this.props.amount) || 100,
      });
    } else {
      updateBetSlip(beslipField);
    }
  }
}

const mapStateToProps = (_, initialProps) => (state) => {
  return {
    oddField: state.sportEvents.eventOddFields[
        `${initialProps.eventId}_${initialProps.oddId}`
      ] &&
      state.sportEvents.eventOddFields[
        `${initialProps.eventId}_${initialProps.oddId}`
      ][initialProps.oddFieldId],
    betSlipField: state.betSlip.betSlipList[initialProps.oddFieldId],
    amount: state.betSlip.amount,
    hideStake: state.betSlip.hideStake,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateBetSlip: (field) => {
      dispatch(updateBetSlip(field));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EventOddField);
